var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-9 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(_vm._s(_vm.title) + " Attendance Graph"),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-3 col-12 d-md-block d-none",
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right ml-1",
                on: {
                  click: function ($event) {
                    return _vm.$router.push(`/attendances?type=${_vm.type}`)
                  },
                },
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(" List View"),
              ]
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("transition", { attrs: { name: "fade" } }, [
              _c("div", { staticClass: "card border-bottom" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v(
                      "\n                                 " +
                        _vm._s(_vm.trans("general.filter")) +
                        "\n                             "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Cohort"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cohort_id,
                                  expression: "cohort_id",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "cohort_id" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.cohort_id = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function ($event) {
                                    return _vm.onCohortChange($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "all" } }, [
                                _vm._v("All Cohorts"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.cohorts, function (cohort) {
                                return _c(
                                  "option",
                                  { domProps: { value: cohort.id } },
                                  [_vm._v(_vm._s(cohort.name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Cycle/Session"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cycle_id,
                                  expression: "cycle_id",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "cycle_id" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.cycle_id = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function ($event) {
                                    return _vm.onSessionChange($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "all" } }, [
                                _vm._v("All Cycle/Sessions"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.cycles, function (cycle) {
                                return _c(
                                  "option",
                                  { domProps: { value: cycle.id } },
                                  [_vm._v(_vm._s(cycle.name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [_vm._v("Term")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.term_id,
                                  expression: "term_id",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "term_id" },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.term_id = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  function ($event) {
                                    return _vm.onTermChange($event)
                                  },
                                ],
                              },
                            },
                            [
                              _c("option", { attrs: { value: "all" } }, [
                                _vm._v("All Terms"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.terms, function (term) {
                                return _c(
                                  "option",
                                  { domProps: { value: term.id } },
                                  [_vm._v(_vm._s(term.name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 col-md-6 col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              {
                staticClass:
                  "card-header d-flex justify-content-between align-items-end",
              },
              [
                _vm.type == "above"
                  ? _c("h4", { staticClass: "card-title" }, [
                      _vm._v("Beneficiaries attendance having 70% and above"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.type == "below"
                  ? _c("h4", { staticClass: "card-title" }, [
                      _vm._v("Beneficiaries having below 70% attendance"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(1),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-content" }, [
              _c(
                "div",
                { staticClass: "card-body pb-0" },
                [
                  _c("beneficiaryChart", {
                    attrs: { data: _vm.getChartData, label: _vm.getChartLabel },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "/home" } }, [_vm._v("Home")]),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _vm._v(
            "\n                                 Statistic\n                             "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [
          _vm._v(
            "\n                                 Attendance\n                             "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "font-medium-5 mb-0" }, [
      _c("i", {
        staticClass: "feather icon-settings text-muted cursor-pointer",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }